@use "~theme/typography";
@use "~theme/breakpoints";

.card {
  padding: 24px;
}

.list {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.separator {
  margin: 24px 0;
  border: none;
  border-bottom: 1px solid var(--blue-01-at-30);

  @include breakpoints.desktop {
    margin: 0 0 24px;
    border: none; // No spacer line on desktop, just whitespace.
  }
}

.headline {
  font-family: "Instrument Serif";
  font-weight: 400;
  font-style: Regular;
  font-size: 28px;
  line-height: 140%;
  letter-spacing: 0%;
  vertical-align: middle;
  color: var(--brand-indigo);
  margin: 0;

  @include breakpoints.desktop {
    font-size: 32px;
    line-height: 140%;
    letter-spacing: 0%;
  }
}

.headlineSeparator {
  margin-bottom: 24px;
  border: none; // Unset default <hr> style
  border-bottom: 1px solid var(--blue-01-at-30);
}

.ctas {
  margin-top: 8px;
  text-align: center;
  margin-left: auto;

  @include breakpoints.desktop {
    text-align: left;
    margin-left: var(--mobile-gutter);
  }
}

.inlineLink {
  @include typography.body-semibold-link;
  border: none;
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover {
    border: none;
    color: var(--highlight-blue);
  }
}